module.exports = __webpack_public_path__ + "assets/img/receipt-2.991afa32.svg";